import { useField } from 'formik'
import React from 'react'
import { Form } from 'react-bootstrap'
import { FormGroup } from 'components'
import { _ } from 'utils'
import { CommonFieldProps } from '../types'

const Checkbox = ({
    name,
    label,
    helperText,
    ...props
}: CommonFieldProps) => {
    const [
        field,
        meta,
    ] = useField({ name })
    const { error, touched } = meta

    return (
        <FormGroup
            controlId={`${field.name}-checkbox`}
            {...props}
        >
            <Form.Check
                custom
                label={label}
                {...field}
                type="checkbox"
            />
            {!(touched && error) && <Form.Text muted>{helperText}</Form.Text>}

            {touched && error && (
                <small className="text-danger invalid-field">
                    {_(error)}
                </small>
            )}
        </FormGroup>
    )
}

export default Checkbox
